import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { api, apiErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { AuthShell } from "@/pages/Login";
import { TermsConsent, TERMS_NEEDED } from "@/components/Legal";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";

export default function Signup() {
  const [f, setF] = useState({ company_name: "", name: "", email: "", password: "" });
  const [agreed, setAgreed] = useState(false);
  const [loading, setLoading] = useState(false);
  const { setSession } = useAuth();
  const navigate = useNavigate();
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!agreed) { toast.error(TERMS_NEEDED); return; }
    setLoading(true);
    try {
      const { data } = await api.post("/auth/signup", { ...f, accept_terms: agreed });
      setSession(data);
      toast.success("Company created");
      navigate("/founder");
    } catch (err) {
      toast.error(apiErr(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Create your company" subtitle="You'll be the founder and can invite your team and independent professionals">
      <form onSubmit={submit} className="space-y-4">
        <div className="space-y-1.5"><Label>Company name</Label>
          <Input data-testid="signup-company" autoComplete="organization" value={f.company_name} onChange={set("company_name")} placeholder="Acme Inc" /></div>
        <div className="space-y-1.5"><Label>Your name</Label>
          <Input data-testid="signup-name" autoComplete="name" value={f.name} onChange={set("name")} placeholder="Jane Doe" /></div>
        <div className="space-y-1.5"><Label>Email</Label>
          <Input data-testid="signup-email" type="email" autoComplete="username" value={f.email} onChange={set("email")} placeholder="jane@acme.dev" /></div>
        <div className="space-y-1.5"><Label>Password</Label>
          <Input data-testid="signup-password" type="password" autoComplete="new-password" value={f.password} onChange={set("password")} placeholder="••••••••" /></div>
        <TermsConsent id="signup-terms" checked={agreed} onChange={setAgreed} />
        <Button type="submit" className="w-full" disabled={loading} data-testid="signup-submit">
          {loading && <Loader2 className="w-4 h-4 animate-spin" />} Create company
        </Button>
      </form>
      <p className="text-sm text-muted-foreground mt-6 text-center">
        Have an account? <Link to="/login" className="text-foreground underline">Sign in</Link>
      </p>
    </AuthShell>
  );
}
